import { MenuItem, TextField } from '@material-ui/core';
import React, { ChangeEvent, FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IBodega from 'Infotrack@Modelos/smartStock/bodegas/entidades/bodega';
import { Autocomplete } from '@material-ui/lab';

interface ICampoBodegaOrigenProps {
    bodegas: IBodega[];
    deshabilitado: boolean;
    manejarCambioCampo: (nombreCampo: keyof IDocumento, nuevoValor: IDocumento[keyof IDocumento]) => any;
    valor?: number;
}

const CampoBodegaOrigen: FunctionComponent<ICampoBodegaOrigenProps> = ({
    bodegas,
    deshabilitado,
    manejarCambioCampo,
    valor,
}) => (
    <Autocomplete
        disabled={deshabilitado}
        getOptionLabel={(b) => b.BodegaDescripcion}
        onChange={(_: ChangeEvent<{}>, bodega: IBodega | null) => {
            manejarCambioCampo('BodegaOrigen', bodega ? bodega.BodegaId! : 0);
        }}
        options={bodegas}
        renderInput={(params) => (
            <TextField
                {...params}
                fullWidth
                label={<Texto id="FormularioDocumento.CampoBodegaOrigen.Nombre" />}
                required
            />
        )}
        value={bodegas.find((b) => b.BodegaId === valor) || null}
    />
);

export default CampoBodegaOrigen;
